import React from "react";
import ReactDOM from "react-dom";
import "../../styles/modal.scss";
import { showModal, hideModal, Subscribe, UnSubscribe, getValue, emptyValue, updateList, compare } from "../../components/utilities";
import ModalHeaderList from "../../components/modalHeaderList";
import ModalSearchMenu from "../../components/modalSearchMenu";
import ModalFooterList from "../../components/modalFooterList";
import ModalReference from "../warehouse/modalReference";
import ModalSelect from "../../components/modalSelect";
import ComponentReferences from "../warehouse/components/componentReferences";
import { Api as Assets } from "../../services/asset";
import { Api as Warehouse } from "../../services/warehouse";

class ListAssetReferences extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: "__ListReferences",
      title: "Referencia",
      name: "references",
      show: false,
      rows: 30,
      class_id: this.props.class_id,
      data: {
        list: [],
        search: "",
        page: 1,
        rows: 30,
        int: 0,
        end: 0,
        count: 0,
        all: 0,
      },
      select: { _id: "-1", caption: "" },
      change: false,
      update: {}
    };
  }

  eventSetData = (e) => {
    setTimeout(() => {
      this.handleUpdate(e);
    }, 500);
  };

  handleSetData = (e) => {
    this.handleUpdate(e);
    this.handleSelect(e);
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeClass = (e) => {
    this.setState({
      class_id: e,
    });
  };

  handleExecute = (e) => {
    const _state = this.props._state || "0";
    if (typeof this.props.onSetData === "function" && _state === "0") {
      this.props.onSetData(e);
    }
    this.handleHide();
  };

  handleHide = () => {
    hideModal(this.state._id);
    this.setState({ show: false });
  };

  handleShow = () => {
    this.setState({
      class_id: this.props.class_id,
      data: {
        ...this.state.data,
        search: "",
      },
      show: true,
    });
  };

  handleClose = () => {
    this.handleHide();
  };

  handleOk = () => {
    if (this.state.change) {
      this.handleExecute(this.state.select);
    } else {
      this.handleHide();
    }
  };

  handleRemove = () => {
    this.handleSelect({});
    this.handleExecute({});
    this.handleHide();
  };

  handleData = (scroll) => {
    const project_id = this.props.project_id;
    const class_id = this.state.class_id;
    const only = this.props.only || true;
    const search = this.state.data.search;
    const rows = this.state.rows;
    if (scroll) {
      const page = this.state.data.page + 1;
      Assets.references(project_id, class_id, only, search, page, rows, this.state.data.list).then((result) => {
        const data = result.data;
        this.setState({
          data: data,
        });
      });
    } else {
      Assets.references(project_id, class_id, only, search, 1, rows, [this.state.select]).then((result) => {
        const data = result.data;
        this.setState({
          data: data,
          change: false,
        });
      });
    }
  };

  handleInit = () => {
    const _id = getValue(this.props.select, "_id", "-1");
    if (_id === "-1") {
      this.handleData(false);
    } else {
      Warehouse.reference(_id).then((result) => {
        const select = emptyValue(result, "data", { _id: "-1", caption: "" });
        this.setState({
          select: select,
          change: false
        });
        this.handleData(false);
      });
    }
  };

  handleSearch = () => {
    this.handleData(false);
  };

  handleSelect = (e) => {
    this.setState({ select: e, change: true });
  };

  handleUpdate = (e) => {
    if (compare(this.state.update, e)) {
      const data = updateList(this.state.data, e);
      this.setState({ data: data, change: true, update: e });
    }
  };

  componentDidMount() {
    Subscribe(`${this.state.name}/${this.props.project_id}`, (event) => this.eventSetData(event));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.show) {
      if (prevState.show !== this.state.show) {
        this.handleInit();
        showModal(this.state._id);
      } else if (prevState.data.state !== this.state.data.state) {
        this.handleData(false);
      } else if (prevState.class_id !== this.state.class_id) {
        this.handleData(false);
      }
    }
  }

  componentWillUnmount() {
    UnSubscribe(`${this.state.name}/${this.props.project_id}`, (event) => this.eventSetData(event));
    hideModal(this.state._id);
  }

  render() {
    if (!this.state.show) {
      return (
        <React.Fragment>
          <div className={this.props.className} onClick={this.handleShow} disabled={!(this.props._state === "0" || !this.props._state)}>
            {this.props.children}
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className={this.props.className} onClick={this.handleShow} disabled={!(this.props._state === "0" || !this.props._state)}>
            {this.props.children}
          </div>
          {ReactDOM.createPortal(
            <div className="modal fade" id={this.state._id} role="dialog">
              <div className="modal-dialog s __modalSingleList" role="document">
                <div className="modal-content">
                  <ModalHeaderList
                    title={this.state.title}
                    handleClose={this.handleClose}
                    state={this.state.data.state}
                    rows={this.state.data.end}
                    all={this.state.data.all}
                  />
                  <div className="modal-body">
                    <div className="modalList">
                      <div className="modalListFind">
                        <ModalSearchMenu
                          name="search"
                          value={this.state.data.search}
                          state={this.state.class_id}
                          onChange={this.handleChange}
                          onSearch={this.handleSearch}
                          onState={this.handleChangeClass}
                          states={[
                            { _state: this.props.class_id, caption: this.props.class_name },
                            { _state: "ALL", caption: "Todas" },
                          ]}
                        />
                      </div>
                      <div className="modalListList">
                        <ComponentReferences
                          id={`${this.state._id}_scroll`}
                          _state={this.state.data.state}
                          list={this.state.data.list}
                          select={this.state.select}
                          getData={this.handleData}
                          onSelect={this.handleSelect}
                        />
                      </div>
                      <div className="modalListSelect">
                        <ModalSelect
                          project_id={this.props.project_id}
                          select={this.state.select}
                          onSetData={this.handleSetData}
                          Modal={ModalReference}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <ModalFooterList
                      project_id={this.props.project_id}
                      _state={this.state.data._state}
                      Modal={ModalReference}
                      onSetData={this.handleSetData}
                      onRemove={this.handleRemove}
                      onClose={this.handleClose}
                      onOk={this.handleOk}
                    />
                  </div>
                </div>
              </div>
            </div>,
            document.getElementById("rootModals")
          )}
        </React.Fragment>
      );
    }
  }
}

function AssetReference(props) {
  const select = getValue(props, "select", { _id: "-1", caption: "" });
  if (props.type === "text") {
    return (
      <React.Fragment>
        <div className="input-group input-group-sm">
          <input className={props.className || "form-control textarea"} readOnly value={select.caption || ""} />
          <div className="input-group-append">
            <ListAssetReferences
              className={props.classNameBtn || "input-group-text textarea-btn"}
              project_id={props.project_id}
              class_id={props.class_id}
              class_name={props.class_name}
              _state={props._state}
              select={select}
              onSetData={props.onSetData}
              disabled={props._state !== "0"}
            >
              <i className="fa fa-ellipsis-h"></i>
            </ListAssetReferences>
          </div>
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="input-group input-group-sm">
          <div className={props.className || "form-control textarea"} readOnly>
            {select.caption || ""}
          </div>
          <div className="input-group-append">
            <ListAssetReferences
              className={props.classNameBtn || "input-group-text textarea-btn"}
              project_id={props.project_id}
              class_id={props.class_id}
              class_name={props.class_name}
              _state={props._state}
              select={select}
              onSetData={props.onSetData}
              disabled={props._state !== "0"}
            >
              <i className="fa fa-ellipsis-h"></i>
            </ListAssetReferences>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export { ListAssetReferences, AssetReference };
